// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"InnerPage_main-wrapper__2iwFn","btn-back":"InnerPage_btn-back__2p0V6"};